namespace $.$$ {
	const poll_ms = 3000
	const busy = ['PENDING', 'ASSEMBLING']

	export class $easyreels_user_recordings extends $.$easyreels_user_recordings {
		@$mol_mem
		list() {
			const list = $mol_wire_stale(() => $easyreels_user_recordings_list({ layout: $easyreels_i18n_layout() }))

			if (list?.recordings.nodes.some(node => busy.includes(node.status))) $mol_state_time.now(poll_ms)

			return list ?? null
		}

		@$mol_mem
		data() {
			const list = this.list()

			return list ? $easyreels_gql_make_map(list.recordings.nodes) : null
		}

		override used_bytes() {
			return this.list()?.me.usedBytes ?? 0
		}

		override limit_bytes() {
			return this.list()?.me.limitBytes ?? 0
		}

		override rows() {
			const data = this.data()

			return data ? data.keys().map(key => this.Item(key)) : [this.Pending()]
		}

		override row(id: string) {
			return this.data()!.get(id)
		}
	}
}
